import BSInfantFruitsAndVegsProduct from 'models/BSInfantFruitsAndVegsProduct'

export const packagingInitialState = {
  category: BSInfantFruitsAndVegsProduct.category,
  subCategory: BSInfantFruitsAndVegsProduct.subCategory,
  ProductType: {
    value: BSInfantFruitsAndVegsProduct.ProductType,
    label: 'Product Type',
  },
  PackageType: {
    value: BSInfantFruitsAndVegsProduct.PackageType,
    label: 'Package Type',
  },
  Size: BSInfantFruitsAndVegsProduct.Size,
  NoAdditionalIngredients: BSInfantFruitsAndVegsProduct.NoAdditionalIngredients,
  Organic: BSInfantFruitsAndVegsProduct.Organic,
  MultiPackageType: BSInfantFruitsAndVegsProduct.MultiPackageType,
  MultiPackageCount: BSInfantFruitsAndVegsProduct.MultiPackageCount,
}

export const productTypeOptions = ['Fruit', 'Vegetable', 'Combo']

export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  { value: 'Jar', label: 'Jar' },
  { value: 'Plastic', label: 'Plastic' },
]
